import React, { useState, useEffect } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { HelpCircle, Sparkles } from "lucide-react";
import { AHJFeatureWalkthroughModal } from "@/components/ahj/AHJFeatureWalkthroughModal";

export const HelpCenter = ({ trigger }: { trigger?: React.ReactNode }) => {
  const [isWalkthroughOpen, setIsWalkthroughOpen] = useState(false);
  const [hasSeenWalkthrough, setHasSeenWalkthrough] = useState(true);

  useEffect(() => {
    // Check if user has seen the walkthrough
    const hasSeen = localStorage.getItem("hasSeenAHJWalkthrough_v1");
    setHasSeenWalkthrough(!!hasSeen);
  }, [isWalkthroughOpen]); // Re-check when modal closes

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          {trigger || (
            <Button variant="ghost" size="icon" className="relative">
              <HelpCircle className="h-5 w-5 text-muted-foreground" />
              {!hasSeenWalkthrough && (
                <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-primary animate-pulse" />
              )}
            </Button>
          )}
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56">
          <DropdownMenuLabel>Help & Resources</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => setIsWalkthroughOpen(true)}>
            <Sparkles className="mr-2 h-4 w-4 text-primary" />
            <span>What's New</span>
            {!hasSeenWalkthrough && (
              <span className="ml-auto h-2 w-2 rounded-full bg-primary" />
            )}
          </DropdownMenuItem>
          {/* <DropdownMenuItem disabled>
            <span>Documentation</span>
          </DropdownMenuItem>
          <DropdownMenuItem disabled>
            <span>Contact Support</span>
          </DropdownMenuItem> */}
        </DropdownMenuContent>
      </DropdownMenu>

      <AHJFeatureWalkthroughModal
        open={isWalkthroughOpen}
        onOpenChange={setIsWalkthroughOpen}
      />
    </>
  );
};
